// Single source of truth for all teaser copy.
// █ runs are rendered as true redaction bars by <RedactedText />.

export const SITE = {
  seriesTitle: "The Fractured Five",
  author: "Tommy Green",
  authorUrl: "https://www.amazon.com/Tommy-Green/e/B0HKHF32MN",
  domain: "thefracturedfive.com",
  logline:
    "A colony lost six seconds. Then it lost two thousand people. The evidence was perfect — and that was the first clue.",
  subLogline:
    "Six books. Five civilisations. One war that ████████ built.",
  classification: "Series dossier · restricted distribution",
  controlStrip:
    "Distribution controlled · books one and two declassified · redactions applied by ██████████ authority · do not ████████",
  dateplaceholder: "[DATE CLASSIFIED]",
  // Amazon links are built per-marketplace at runtime from the ASINs in
  // src/lib/amazon.js, so international readers land on their own store.
  // These .com URLs remain the canonical values used for SEO/structured data.
  buyUrl: "https://www.amazon.com/dp/B0HKF8RYNQ",
  buyLabel: "Get Book One on Kindle",
  buyPaperbackUrl: "https://www.amazon.com/dp/B0HKNW67JS",
  buyPaperbackLabel: "Paperback",
  bookTwoUrl: "https://www.amazon.com/dp/B0HK8DZCMY",
  bookTwoLabel: "Get Book Two",
  pullQuote: {
    text: "There is no truth in a record. There is only evidence, and how badly ████████ wants it to mean something.",
    attribution:
      "Senior Investigator Seren Vale · Directorate of ███████ Integrity"
  },
  telemetry: [
    { label: "Model confidence", value: "99.997%" },
    { label: "Independent buffers lost", value: "ALL" },
    { label: "Interval unaccounted", value: "6.13 s" },
    { label: "Originating authority", value: "████████████" },
    { label: "Link classification", value: "NO PERSON DETECTED" }
  ]
};

export const NULL_SIX = {
  title: "Null Six",
  kicker: "Anomaly file 06",
  lede:
    "Six point one three seconds of station time had no source data. Not corrupted. Not overwritten. Absent — identically, simultaneously, across buffers that shared no power, no storage and no ███████ tier.",
  body:
    "It happens again. On a ██████ shield fleet. On a living ship in bloom. Inside a civilisation that remembers together. Every time an atrocity needs a culprit, six seconds go missing first, and the records that survive tell a story so clean that ████████ must have written it.",
  timeline: [
    {
      time: "02:17:00",
      event: "Unresolved ████████ arrival. No vessel detected."
    },
    {
      time: "02:18:48",
      event: "Invalid authentication. Maintenance Team 7-C does not exist."
    },
    {
      time: "02:18:54",
      event: "NULL SIX — 6.13 s unaccounted across all buffers.",
      gap: true
    },
    {
      time: "02:19:31",
      event: "First hostile impact. Every system reports ███████."
    },
    {
      time: "02:31:00",
      event: "Coordinated control lost. Confirmed dead: 2,184."
    }
  ],
  note:
    "Note appended by S. Vale: the absence of data is not proof of an event. Deliberate absence is evidence of ████████████."
};

export const BOOKS = [
  {
    number: 1,
    numeral: "I",
    title: "The Fracture",
    epigraph: "For the ones who go back.",
    status: "DECLASSIFIED",
    locked: false,
    releaseDate: "Available now",
    released: true,
    pov: "Seren Vale · Veydran Directorate of Systems Integrity",
    fragment:
      "An industrial colony dies at the hands of its own machines while every instrument insists nothing is wrong. The forensic model names the Kharak at 99.997% confidence. Investigator Seren Vale is sent because 99.997 is not one hundred.",
    excerptAvailable: true
  },
  {
    number: 2,
    numeral: "II",
    title: "The Weight of Blood",
    epigraph: "For the ones who carry the weight.",
    status: "DECLASSIFIED",
    locked: false,
    releaseDate: "Available now",
    released: true,
    // One Amazon detail page carries both the Kindle and paperback editions.
    asin: "B0HK8DZCMY",
    singleListing: true,
    buyLabel: "Book Two",
    pov: "Shield-Captain ██████ ████ · Kharak Shieldline",
    fragment:
      "A Shield-Captain is ordered to ████████ a settlement no record admits existed. The orders are █████████. The authority behind them is ███. What she carries afterward has a weight, and weight is █████████."
  },
  {
    number: 3,
    numeral: "III",
    title: "The Living War",
    epigraph: "For the things that change and remain themselves.",
    status: "SEALED",
    locked: true,
    releaseDate: "11 January 2027",
    pov: "████ █████ · ███████ biological survey",
    fragment:
      "A living ship turns on its own ████. Twenty-seven base pairs that belong to no genome on ██████ record appear in vessels that never ███████. Then the Bloomfall reaches inhabited ██████."
  },
  {
    number: 4,
    numeral: "IV",
    title: "The Silent Mind",
    epigraph: "For the voices that remain their own.",
    status: "SEALED",
    locked: true,
    releaseDate: "3 March 2027",
    pov: "████████ · Sythren consensus",
    fragment:
      "A civilisation that remembers together begins to remember █████████. One killing. Ten thousand witnesses. No two recollections agree, and one of them was ████████ in."
  },
  {
    number: 5,
    numeral: "V",
    title: "The Last Adaptation",
    epigraph: "For the people who make home worth returning to.",
    status: "SEALED",
    locked: true,
    releaseDate: "23 April 2027",
    pov: "Cael Aran · city-ship ██████",
    fragment:
      "On a city-ship older than its own charts, a sealed section opens itself from the ██████. There is a name written on the wall within, and it belongs to a man everyone agreed to ██████."
  },
  {
    number: 6,
    numeral: "VI",
    title: null,
    epigraph: null,
    status: "CLASSIFIED",
    locked: true,
    hardLocked: true,
    releaseDate: "13 June 2027",
    pov: "██████████████████████",
    fragment:
      "█████████ ████ ████████████ ██████ ██████████ ████ ████████████████ █████ ████████████.",
    note: "Title withheld. Contents withheld. Date — 6.13.2027 — confirmed."
  }
];

export const SCHEDULE_NOTE = {
  kicker: "Schedule declassified",
  heading: "Six dates. One of them is 6.13.",
  body:
    "Books One and Two are out now. The remaining four files publish on the dates listed and those dates will not move.",
  sixth:
    "The sixth title stays withheld until publication: naming it would give away the ██████ the first five books are circling. Its date is not withheld.",
  finalLine: "13 June 2027. 6.13. That was never a coincidence."
};

export const FOOTER_CHECKSUM = "6.13 · NULL-SIX · 4f7a████d21b████9c03██████e8";
